module.exports = __webpack_public_path__ + "static/media/phone_6.0c472363.png";